import { Component, Input } from '@angular/core';

@Component({
	template: require('./landing-certification.component.html'),
	selector: 'vcm-landing-certification'
})

export class LandingCertificationComponent {
	@Input() resources: any;
}
